(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selmavie-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRoot = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const countdown = root.querySelector('[data-countdown]');
      const updateCountdown = () => {
        if (!countdown) return;
        const now = new Date();
        const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        const remaining = Math.max(0, end - now);
        const parts = [Math.floor(remaining / 36e5), Math.floor(remaining / 6e4) % 60, Math.floor(remaining / 1e3) % 60];
        countdown.textContent = parts.map((value) => String(value).padStart(2, '0')).join(':');
      };
      updateCountdown();
      window.setInterval(updateCountdown, 1000);

      const perks = [...root.querySelectorAll('[data-perk]')];
      if (perks.length > 1) {
        let perkIndex = 0;
        window.setInterval(() => {
          perks[perkIndex].classList.remove('is-active');
          perkIndex = (perkIndex + 1) % perks.length;
          perks[perkIndex].classList.add('is-active');
        }, 3500);
      }

      const picker = root.querySelector('[data-featured-picker]');
      const form = picker?.closest('form');
      const variantInput = form?.querySelector('[data-featured-variant-id]');
      const variantsData = root.querySelector('[data-featured-variants]');
      const price = root.querySelector('[data-flavia-price]');
      const button = form?.querySelector('button[name="add"]');
      const buyNowButton = form?.querySelector('[data-featured-buy-now]');
      const status = form?.querySelector('[data-featured-status]');
      const savings = root.querySelector('[data-featured-savings]');
      const mainImage = root.querySelector('.sm-featured-main-image');
      const selectedColor = root.querySelector('[data-featured-color]');
      const selectedSize = root.querySelector('[data-featured-size]');
      const groups = picker ? [...picker.querySelectorAll('[data-featured-option]')] : [];
      let variants = [];

      try {
        variants = JSON.parse(variantsData?.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const selectedValues = () => groups.map((group) => group.querySelector('[data-featured-option-value]:checked')?.value);

      const updateSizeAvailability = () => {
        if (groups.length < 2) return;
        const selectedColor = groups[0].querySelector('[data-featured-option-value]:checked')?.value;
        const sizeInputs = [...groups[1].querySelectorAll('[data-featured-option-value]')];
        sizeInputs.forEach((input) => {
          const match = variants.find((variant) => variant.options[0] === selectedColor && variant.options[1] === input.value);
          input.disabled = !match?.available;
        });
        const selectedSize = groups[1].querySelector('[data-featured-option-value]:checked');
        if (selectedSize?.disabled) {
          const firstAvailable = sizeInputs.find((input) => !input.disabled);
          if (firstAvailable) firstAvailable.checked = true;
        }
      };

      const syncVariant = () => {
        if (!picker || !variantInput) return;
        updateSizeAvailability();
        const selections = selectedValues();
        const variant = variants.find((item) => item.options.every((value, index) => value === selections[index]));
        const current = price?.querySelector('strong');
        const compare = price?.querySelector('s');

        if (!variant) {
          variantInput.value = '';
          if (button) button.disabled = true;
          if (buyNowButton) buyNowButton.disabled = true;
          if (status) {
            status.textContent = 'Combinación no disponible';
            status.classList.add('is-unavailable');
          }
          return;
        }

        variantInput.value = variant.id;
        if (current) current.textContent = variant.price;
        if (compare) {
          compare.textContent = variant.compare;
          compare.hidden = !variant.onSale;
        }
        if (savings) {
          const savingsValue = savings.querySelector('strong');
          if (savingsValue) savingsValue.textContent = variant.savings;
          savings.hidden = !variant.onSale;
        }
        if (selectedColor) selectedColor.textContent = variant.options[0] || '';
        if (selectedSize) selectedSize.textContent = variant.options[1] || '';
        const selectedColorInput = picker.querySelector('.sm-variant-group--color [data-featured-option-value]:checked');
        const selectedImage = selectedColorInput?.dataset.featuredColorImage || variant.image;
        const selectedImageAlt = selectedColorInput?.dataset.featuredColorImageAlt || variant.imageAlt;
        if (mainImage && selectedImage) {
          mainImage.srcset = '';
          mainImage.src = selectedImage;
          mainImage.alt = selectedImageAlt || '';
        }
        if (button) button.disabled = !variant.available;
        if (buyNowButton) buyNowButton.disabled = !variant.available;
        if (status) {
          status.textContent = variant.available ? 'Disponible' : 'Agotada';
          status.classList.toggle('is-unavailable', !variant.available);
        }
      };

      picker?.addEventListener('change', syncVariant);
      syncVariant();

      buyNowButton?.addEventListener('click', async () => {
        if (!variantInput?.value || buyNowButton.disabled) return;
        const originalText = buyNowButton.textContent;
        buyNowButton.disabled = true;
        buyNowButton.textContent = 'PROCESANDO…';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
        } catch (error) {
          buyNowButton.textContent = originalText;
          buyNowButton.disabled = false;
          if (status) {
            status.textContent = 'No se ha podido iniciar la compra. Inténtalo de nuevo.';
            status.classList.add('is-unavailable');
          }
        }
      });

    };

    const initializeAll = (scope) => {
      if (scope.matches?.('[data-sm-homepage]')) initializeRoot(scope);
      scope.querySelectorAll?.('[data-sm-homepage]').forEach(initializeRoot);
    };

    const start = () => initializeAll(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
